export const SET_USER_INFO = 'SET_USER_INFO';
export const ENABLE_LOADING = 'ENABLE_LOADING';
export const DISABLE_LOADING = 'DISABLE_LOADING';
export const FETCH_USER_INFO_FAILED = 'FETCH_USER_INFO_FAILED';

export const SET_SELECTED_DATE = 'SET_SELECTED_DATE';
export const SET_CHANGED_DATE = 'SET_CHANGED_DATE';
export const SET_CURRENT_LIST = 'SET_CURRENT_LIST';
export const SET_CURRENT_TAG = 'SET_CURRENT_TAG';

export const SET_SELECTED_ITEM = 'SET_SELECTED_ITEM';
export const SET_SELECTED_ITEM_EMPTY = 'SET_SELECTED_ITEM_EMPTY';

export const SET_MOBILE = 'SET_MOBILE';
export const SET_CURRENT_COLOR = 'SET_CURRENT_COLOR';
